import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SBlogger component used for Blogger social network
 * @link https://www.blogger.com/
 * @example https://www.blogger.com/blog-this.g?u=https%3A%2F%2Fgithub.com%2F&t=Text&n=Title/
 */
/**
 * Share parameters for link
 * @link https://stackoverflow.com/a/22583473/13374604
 * url => u
 * title => n
 * text => t
 */

var SBlogger = /* #__PURE__ */defineComponent({
  name: 'SBlogger',
  mixins: [BaseSocials('Blogger', undefined, undefined, undefined, true)],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://www.blogger.com/blog-this.g';
      var shareOptions = this.shareOptions;
      var url = shareOptions.url,
          title = shareOptions.title,
          text = shareOptions.text;
      var serialisedParams = getSerialisedParams({
        u: url,
        t: text,
        n: title
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SBlogger;
